import React, { useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { AppBar, Box, Button, CircularProgress, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { InvoiceEditor } from "./InvoiceEditor";
import { useUpdateInvoice } from "../../hooks/data/data_invoice";
import { TransitionProps } from "@mui/material/transitions";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { IInvoiceType } from "../../interfaces/IInvoiceType";
import { IRecipientOfPayment } from "../../interfaces/IRecipientOfPayment";




const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



interface IProps {
    isOpenEdit: boolean;
    setIsOpenEdit: Function;
    
    editInv: IInvoice;
    setEditInv: Function;

    bankAccounts: IRecipientOfPayment[];
    invoices: IInvoice[];
    invStates: IInvoiceState[];
    invTypes: IInvoiceType[];

    setFeetback: Function;
    refetchFunction: Function;
}


export const InvoiceEditDialog:React.FC<IProps> = ({
    isOpenEdit,
    setIsOpenEdit,
    editInv,
    setEditInv,

    bankAccounts,
    invoices,
    invStates,
    invTypes,

    setFeetback,
    refetchFunction
}) => {
    const { updateInvoice, isPendingUpdateInvoice } = useUpdateInvoice();
    const isPending = isPendingUpdateInvoice;
    //
    const [isOpenNew,setIsOpenNew] = useState(false);
    const [isOpenAssignMaterial,setIsOpenAssignMaterial] = useState(false);

    const handleClose = () => {
        setIsOpenEdit(false);
    }

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            await updateInvoice(editInv);
            setIsOpenNew(false)
            setFeetback({
                open: true,
                message: "Erfolgreich gespeichert!",
                severity: "success"
            })
            refetchFunction();
            setIsOpenEdit(false);
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }


    return(
        <>

            <Dialog fullScreen open={isOpenEdit} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar sx={{ position: "relative" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <GridCloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Rechnungseditor
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Box style={{ marginBottom: 0 }} sx={{ m: 5 }}>
                    <form onSubmit={handleSubmit}>
                        <InvoiceEditor
                            key={`edit-inv-${editInv.id}`}
                            editInv={editInv}
                            setEditInv={setEditInv}
                            invocies={invoices}
                            bankAccounts={bankAccounts}
                            invStates={invStates}
                            invTypes={invTypes}

                            isOpenAssignMaterial={isOpenAssignMaterial}
                            isOpenNew={isOpenNew}
                            setIsOpenAssignMaterial={setIsOpenAssignMaterial}
                            setIsOpenNew={setIsOpenNew}
                        />
                        <Box
                            sx={{
                                position: "sticky",
                                bottom: 30,
                                right: 0,
                                zIndex: 100,
                                p: 2,
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                                gap: 2,
                            }}
                        >

                            {/* Leere Position nur im Material-Tab */}
                            {[10,30,40,50].includes(editInv.InvoiceType) && (
                                <Button
                                    variant="contained"
                                    sx={{ width: 150 }}
                                    disabled={isPending}
                                    onClick={() => setIsOpenNew(true)}
                                >
                                    {(editInv.InvoiceType === 10) 
                                        ? <>Leere Position</>
                                        : <>Neue Position</>
                                    }
                                </Button>
                            )}
                            {editInv.InvoiceType === 10  && (
                                <Button
                                    variant="contained"
                                    sx={{ width: 150 }}
                                    disabled={isPending}
                                    onClick={() => setIsOpenAssignMaterial(true)}
                                >
                                    Material zuweisen
                                </Button>
                            )}


                            {/* Speichern-Button */}
                            <Button variant="contained" sx={{ minWidth: 100 }} disabled={isPending} type="submit">
                                {isPending ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <span>Speichern</span>
                                        <CircularProgress size={20} />
                                    </Box>
                                ) : (
                                    "Speichern"
                                )}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Dialog>

        </>
    )
}